import { Toasts } from '@fourthwall/components'
import type { UpdateWelcomePostsPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { errorMessageSelector } from '@fourthwall/utils/dist/selectors'
import { useMutation } from '@tanstack/react-query'

export const useUpdateWelcomePostsMutation = () => {
  const updateWelcomePostsMutation = useMutation({
    mutationFn: async (payload: UpdateWelcomePostsPayload) => {
      const { data } = await MembershipsCreatorApiClient.updateWelcomePosts(payload)

      return data
    },
    onError: (error: ApiError) => {
      const errorMessage = errorMessageSelector(error.response?.data)

      Toasts.notify(errorMessage, { type: 'error' })
    },
  })

  return { updateWelcomePostsMutation }
}
